import {scrollTo} from "./scrollTo";

export function hereSection() {
  $(".here-section").on('click', ".scroll-down", function (e) {
    e.preventDefault();

    let section = $(e.delegateTarget);

    scrollTo(parseInt(section.outerHeight() + section.offset().top));
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hereSection.js